/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

 import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { User } from '@api/models/user';

/**
 * Service to manage the user's authentication
 */
@Injectable()
export abstract class AuthenticationService {

    /**
     * Login
     * @return Observable User's information
     */
    abstract login(): Observable<User>;

    /**
     * Log out from the active session
     */
    abstract logout(): void;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/authentication.service.ts